import { topics } from '@/mocks/home';
import Reveal from '@/pages/home/components/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopicBoard() {
  const [lead, ...rest] = topics;

  return (
    <section id="topic" className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="专题板块"
            icon="ri-stack-line"
            title="专题把同一话题的线索串成脉络"
            desc="专题是围绕一个话题人工整理出的合集，按时间线排列、上下文完整。想弄清一件事的来龙去脉，从专题进比翻列表高效得多。"
          />
        </Reveal>

        <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-[1.15fr_1fr]">
          <Reveal>
            <article className="card-hover group relative h-full min-h-[320px] overflow-hidden rounded-lg border border-background-200">
              <img
                src={lead.cover}
                alt={`${lead.title}专题封面 - 黑料网1`}
                title={`${lead.title} - 黑料网1 专题板块`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/45 to-foreground-950/10"></div>
              <div className="relative flex h-full flex-col justify-end p-6">
                <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-medium text-background-50">
                  <i className="ri-star-smile-line text-xs"></i>
                  {lead.tag} · 主推
                </span>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-background-100/90">
                  {lead.desc}
                </p>
                <div className="mt-4 flex items-center gap-4 text-xs text-background-100/80">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-article-line"></i>
                    {lead.count} 篇整理
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line"></i>
                    按时间线排列
                  </span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="flex flex-col gap-4">
            {rest.map((topic, index) => (
              <Reveal key={topic.id} delay={index * 60}>
                <article className="card-hover group flex h-full gap-4 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-primary-300">
                  <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md sm:w-32">
                    <img
                      src={topic.cover}
                      alt={`${topic.title}专题封面 - 黑料网1`}
                      title={`${topic.title} - 黑料网1 专题板块`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col justify-center">
                    <div className="flex items-center gap-2">
                      <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                        {topic.tag}
                      </span>
                      <span className="text-[11px] text-foreground-500">{topic.count} 篇</span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
                      {topic.title}
                    </h3>
                    <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                      {topic.desc}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}